import styled, { keyframes, css } from 'styled-components'

const fadeIn = keyframes`
  from {
    transform: translateY(10px);
  }

  to {
   transform: translateY(0px);
  }
`
export const Notification = styled.div`
    max-height: 0;
    opacity: 0;
    margin: 0;
    font-family: 'Mabry Pro', sans-serif;
    transition: max-height 100ms linear, opacity 500ms linear 100ms,
        transform 500ms linear 100ms, height 100ms linear;
    font-weight: 400;
    font-size: 13px;
    line-height: 17px;
    animation: ${fadeIn} 0.5s linear;

    ${({ error, errormessage }) =>
        (error || errormessage) &&
        css`
            color: #d24339;
            max-height: 1000px;
            opacity: 1;
            margin-top: 5px;
            margin-bottom: 5px;
        `};
    ${({ message, successmessage }) =>
        (message || successmessage) &&
        css`
            color: #018950;
            max-height: 1000px;
            opacity: 1;
            margin-top: 5px;
            margin-bottom: 5px;
        `}
`
